import { Auth as BaseAuth } from "@sisuwellness/utilities";
import APIClient from "./APIClient";

/**
 * In-memory storage fallback for when localStorage is blocked
 * (e.g., iOS Safari with strict privacy settings, incognito mode)
 */
class MemoryStorage {
    constructor() {
        this.storage = new Map();
    }

    setItem(key, value) {
        this.storage.set(key, String(value));
    }

    getItem(key) {
        return this.storage.has(key) ? this.storage.get(key) : null;
    }

    removeItem(key) {
        this.storage.delete(key);
    }

    clear() {
        this.storage.clear();
    }
}

/**
 * Safely get a storage interface, falling back to in-memory storage
 * if localStorage is blocked by browser privacy settings
 */
function getStorageInterface() {
    try {
        // Test if localStorage is accessible
        const testKey = "__storage_test__";
        window.localStorage.setItem(testKey, "test");
        window.localStorage.removeItem(testKey);
        return window.localStorage;
    } catch (e) {
        // localStorage blocked (iOS Safari strict privacy, incognito, etc.)
        console.warn("localStorage blocked, using in-memory storage fallback:", e);
        return new MemoryStorage();
    }
}

export class Auth extends BaseAuth {
    /**
     * @param {Storage} storageInterface
     * @param {APIClient} APIClient
     */
    constructor(storageInterface, APIClient) {
        super(APIClient);
        this.storageInterface = storageInterface;
    }

    _setValue(key, value) {
        let result = this.storageInterface.setItem(key, value);
        return Promise.resolve(result);
    }

    _getValue(key) {
        let value = this.storageInterface.getItem(key);
        return Promise.resolve(value);
    }

    _removeValue(key) {
        let result = this.storageInterface.removeItem(key);
        return Promise.resolve(result);
    }
}

const auth = new Auth(getStorageInterface(), APIClient);
export default auth;
